import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-full w-full items-center justify-center" }

import { TranslateKey, useInject } from '@/composables/use-inject';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppComingSoon',
  setup(__props) {

const translate = useInject(TranslateKey);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_unref(translate)('generic.comingSoon')) + "...", 1)
  ]))
}
}

})